import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getWmsAlmacenById, getWmsPasillosByAlmacen, getWmsUbicaciones, createWmsUbicacion, updateWmsUbicacion, deleteWmsUbicacion, editarUbicacionesMasiva, previewEditarUbicacionesMasiva, createWmsUbicacionesBatch, createWmsPasillo, updateWmsPasillo, getWmsImpresorasByAlmacen, createWmsImpresora, updateWmsImpresora, deleteWmsImpresora } from '../../api.wms';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import PrintIcon from '@mui/icons-material/Print';

const WmsAlmacenDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [almacen, setAlmacen] = useState(null);
  const [pasillos, setPasillos] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);
  const [ubicModalOpen, setUbicModalOpen] = useState(false);
  const [editUbic, setEditUbic] = useState(null);
  const [ubicForm, setUbicForm] = useState({ codigo: '', tipo: '', zona: '', capacidad: '', lado: '', ubicacion: '', nivel: '', posicion: '', pasillo_id: '' });
  const [ubicacionesACrear, setUbicacionesACrear] = useState(1);
  const [nivelesACrear, setNivelesACrear] = useState(1);
  const [posicionesPorNivelACrear, setPosicionesPorNivelACrear] = useState(1);
  const [previewUbics, setPreviewUbics] = useState([]);
  const [capacidadTipo, setCapacidadTipo] = useState('m3');
  const [editMasivaOpen, setEditMasivaOpen] = useState(false);
  const [editMasivaUbic, setEditMasivaUbic] = useState(null);
  const [editMasivaNiveles, setEditMasivaNiveles] = useState(1);
  const [editMasivaPosiciones, setEditMasivaPosiciones] = useState(1);
  const [editMasivaPreview, setEditMasivaPreview] = useState([]);
  const [editMasivaInfo, setEditMasivaInfo] = useState(null);
  const [pasilloModalOpen, setPasilloModalOpen] = useState(false);
  const [pasilloForm, setPasilloForm] = useState({ numero: '', ubicaciones_por_pasillo: 1, niveles: 1, posiciones_por_nivel: 1 });
  const [editPasillo, setEditPasillo] = useState(null);
  const [impresoras, setImpresoras] = useState([]);
  const [impresoraModalOpen, setImpresoraModalOpen] = useState(false);
  const [editImpresora, setEditImpresora] = useState(null);
  const [impresoraForm, setImpresoraForm] = useState({ nombre: '', tipo_conexion: '', link: '' });
  const [loadingImpresoras, setLoadingImpresoras] = useState(false);
  const [errorImpresoras, setErrorImpresoras] = useState('');
  const [activeItem, setActiveItem] = useState('almacenes');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const almacenData = await getWmsAlmacenById(id);
        setAlmacen(almacenData);
        const pasillosData = await getWmsPasillosByAlmacen(id);
        setPasillos(pasillosData);
        const ubicacionesData = await getWmsUbicaciones();
        setUbicaciones(ubicacionesData.filter(u => String(u.almacen_id) === String(id)));
      } catch (error) {
        setAlmacen(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const openUbicModal = (ubic = null) => {
    setEditUbic(ubic);
    setUbicForm(ubic ? { ...ubic } : { codigo: '', tipo: '', zona: '', capacidad: '', lado: '', ubicacion: '', nivel: '', posicion: '', pasillo_id: '' });
    setUbicModalOpen(true);
  };
  const closeUbicModal = () => { setUbicModalOpen(false); setEditUbic(null); };
  const handleUbicFormChange = e => {
    const { name, value } = e.target;
    let newForm = { ...ubicForm, [name]: value };
    if (name === 'tipo') {
      setPreviewUbics([]);
      if (value === 'Staging') {
        newForm = { ...newForm, staging_areas: '', staging_posiciones: '', pasillo_id: '', cantidad: '', niveles: '', posiciones: '' };
      } else {
        newForm = { ...newForm, staging_areas: '', staging_posiciones: '' };
      }
    }
    setUbicForm(newForm);
  };
  const getPasilloSeleccionado = () => pasillos.find(p => String(p.id) === String(ubicForm.pasillo_id));
  const generarPreviewUbics = () => {
    const pasillo = getPasilloSeleccionado();
    if (!pasillo) return setPreviewUbics([]);
    const codigosExistentes = new Set(ubicaciones.map(u => u.codigo));
    const totalPorLado = Math.floor(pasillo.ubicaciones_por_pasillo / 2);
    const maxUbics = Math.min(
      Number(ubicacionesACrear) * Number(nivelesACrear) * Number(posicionesPorNivelACrear),
      pasillo.ubicaciones_por_pasillo * pasillo.niveles * pasillo.posiciones_por_nivel
    );
    let arr = [];
    let count = 0;
    for (let lado of ['A', 'B']) {
      for (let u = 1; u <= totalPorLado; u++) {
        for (let n = 1; n <= nivelesACrear; n++) {
          for (let pos = 1; pos <= posicionesPorNivelACrear; pos++) {
            if (count >= maxUbics) break;
            const codigo = `${String(pasillo.numero).padStart(3, '0')}-${lado}-${String(u).padStart(3, '0')}-${String(n).padStart(3, '0')}-${String(pos).padStart(3, '0')}`;
            if (!codigosExistentes.has(codigo)) {
              arr.push({
                codigo,
                tipo: ubicForm.tipo || 'Rack',
                zona: ubicForm.zona || '',
                capacidad: ubicForm.capacidad || '',
                lado,
                ubicacion: u,
                nivel: n,
                posicion: pos,
                pasillo_id: pasillo.id
              });
              count++;
            }
          }
          if (count >= maxUbics) break;
        }
        if (count >= maxUbics) break;
      }
      if (count >= maxUbics) break;
    }
    setPreviewUbics(arr);
  };

  useEffect(() => {
    if (ubicModalOpen && ubicForm.pasillo_id && ubicacionesACrear > 0 && nivelesACrear > 0 && posicionesPorNivelACrear > 0) {
      generarPreviewUbics();
    } else {
      setPreviewUbics([]);
    }
  }, [ubicForm.pasillo_id, ubicacionesACrear, nivelesACrear, posicionesPorNivelACrear, ubicForm.tipo, ubicForm.zona, ubicForm.capacidad, ubicModalOpen]);

  const handleUbicSubmit = async (e) => {
    e.preventDefault();
    if (ubicForm.tipo === 'Staging') {
      const areas = parseInt(ubicForm.staging_areas);
      const posiciones = parseInt(ubicForm.staging_posiciones);
      if (!areas || !posiciones) return alert('Completa ambos campos de staging');
      if (!ubicForm.pasillo_id) return alert('Selecciona un pasillo de staging');
      const codigosExistentes = new Set(ubicaciones.map(u => u.codigo));
      let ubicacionesBatch = [];
      for (let a = 1; a <= areas; a++) {
        for (let p = 1; p <= posiciones; p++) {
          const codigo = `STAGE-${String(a).padStart(3, '0')}-${String(p).padStart(3, '0')}`;
          if (!codigosExistentes.has(codigo)) {
            ubicacionesBatch.push({
              codigo,
              tipo: 'Staging',
              almacen_id: Number(id),
              lado: '',
              nivel: 1,
              ubicacion: a,
              posicion: p,
              pasillo_id: ubicForm.pasillo_id
            });
          }
        }
      }
      if (ubicacionesBatch.length === 0) return alert('No hay ubicaciones nuevas a crear (puede que ya existan todas)');
      try {
        await createWmsUbicacionesBatch(ubicacionesBatch);
        const ubicacionesData = await getWmsUbicaciones();
        setUbicaciones(ubicacionesData.filter(u => String(u.almacen_id) === String(id)));
        closeUbicModal();
      } catch {
        alert('Error al guardar ubicaciones de staging');
      }
      return;
    }
    const pasillo = getPasilloSeleccionado();
    if (!pasillo) return alert('Selecciona un pasillo válido');
    if (previewUbics.length === 0) return alert('No hay ubicaciones a crear');
    try {
      const ubicacionesBatch = previewUbics.map(ubic => {
        const { capacidad_tipo, ...ubicSinTipo } = ubic;
        return { ...ubicSinTipo, almacen_id: Number(id) };
      });
      await createWmsUbicacionesBatch(ubicacionesBatch);
      const ubicacionesData = await getWmsUbicaciones();
      setUbicaciones(ubicacionesData.filter(u => String(u.almacen_id) === String(id)));
      closeUbicModal();
    } catch {
      alert('Error al guardar ubicación');
    }
  };
  const handleDeleteUbic = async (ubic) => {
    if (window.confirm('¿Eliminar ubicación?')) {
      await deleteWmsUbicacion(ubic.id);
      const ubicacionesData = await getWmsUbicaciones();
      setUbicaciones(ubicacionesData.filter(u => String(u.almacen_id) === String(id)));
    }
  };

  const openEditMasiva = async (padre) => {
    const maxNivel = Math.max(...padre.hijas.map(h => h.nivel || 1));
    const maxPosicion = Math.max(...padre.hijas.map(h => h.posicion || 1));
    setEditMasivaUbic(padre);
    setEditMasivaNiveles(maxNivel);
    setEditMasivaPosiciones(maxPosicion);
    setEditMasivaOpen(true);
    try {
      const params = {
        pasillo_id: padre.pasillo_id,
        lado: padre.lado,
        ubicacion: padre.ubicacion,
        niveles: maxNivel,
        posiciones: maxPosicion
      };
      const resp = await previewEditarUbicacionesMasiva(params);
      setEditMasivaInfo(resp);
    } catch (e) {
      setEditMasivaInfo(null);
    }
  };
  const closeEditMasiva = () => { setEditMasivaOpen(false); setEditMasivaInfo(null); };

  useEffect(() => {
    if (editMasivaOpen && editMasivaUbic) {
      (async () => {
        try {
          const params = {
            pasillo_id: editMasivaUbic.pasillo_id,
            lado: editMasivaUbic.lado,
            ubicacion: editMasivaUbic.ubicacion,
            niveles: editMasivaNiveles,
            posiciones: editMasivaPosiciones
          };
          const resp = await previewEditarUbicacionesMasiva(params);
          setEditMasivaInfo(resp);
        } catch (e) {
          setEditMasivaInfo(null);
        }
      })();
    }
  }, [editMasivaOpen, editMasivaUbic, editMasivaNiveles, editMasivaPosiciones]);

  const handleEditMasivaSubmit = async (e) => {
    e.preventDefault();
    if (!editMasivaUbic) return;
    try {
      const payload = {
        pasillo_id: editMasivaUbic.pasillo_id,
        lado: editMasivaUbic.lado,
        ubicacion: editMasivaUbic.ubicacion,
        niveles: editMasivaNiveles,
        posiciones: editMasivaPosiciones
      };
      await editarUbicacionesMasiva(payload);
      const ubicacionesData = await getWmsUbicaciones();
      setUbicaciones(ubicacionesData.filter(u => String(u.almacen_id) === String(id)));
      closeEditMasiva();
      alert('Edición masiva realizada correctamente.');
    } catch (error) {
      alert('Error al realizar la edición masiva: ' + (error?.response?.data?.detail || error.message));
    }
  };

  const openPasilloModal = (pasillo = null) => {
    if (pasillo) {
      setEditPasillo(pasillo);
      setPasilloForm({
        numero: pasillo.numero,
        ubicaciones_por_pasillo: pasillo.ubicaciones_por_pasillo,
        niveles: pasillo.niveles,
        posiciones_por_nivel: pasillo.posiciones_por_nivel
      });
    } else {
      setEditPasillo(null);
      setPasilloForm({ numero: '', ubicaciones_por_pasillo: 1, niveles: 1, posiciones_por_nivel: 1 });
    }
    setPasilloModalOpen(true);
  };
  const closePasilloModal = () => { setPasilloModalOpen(false); setEditPasillo(null); };
  const handlePasilloFormChange = e => setPasilloForm({ ...pasilloForm, [e.target.name]: e.target.value });

  const handlePasilloSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editPasillo) {
        await updateWmsPasillo(editPasillo.id, { ...pasilloForm, almacen_id: id });
      } else {
        await createWmsPasillo({ ...pasilloForm, almacen_id: id });
      }
      const pasillosData = await getWmsPasillosByAlmacen(id);
      setPasillos(pasillosData);
      closePasilloModal();
    } catch {
      alert('Error al guardar pasillo');
    }
  };

  useEffect(() => {
    setImpresoras([
    ]);
  }, []);

  const fetchImpresoras = async () => {
    setLoadingImpresoras(true);
    setErrorImpresoras('');
    try {
      const data = await getWmsImpresorasByAlmacen(id);
      setImpresoras(data);
    } catch (e) {
      setImpresoras([]);
      setErrorImpresoras('Error al cargar impresoras');
    } finally {
      setLoadingImpresoras(false);
    }
  };

  useEffect(() => {
    fetchImpresoras();
  }, [id]);

  const openImpresoraModal = (imp = null) => {
    setEditImpresora(imp);
    setImpresoraForm(imp ? { ...imp } : { nombre: '', tipo_conexion: '', link: '' });
    setImpresoraModalOpen(true);
  };
  const closeImpresoraModal = () => { setImpresoraModalOpen(false); setEditImpresora(null); };
  const handleImpresoraFormChange = e => setImpresoraForm({ ...impresoraForm, [e.target.name]: e.target.value });

  const handleImpresoraSubmit = async e => {
    e.preventDefault();
    setLoadingImpresoras(true);
    setErrorImpresoras('');
    try {
      const { id: _omit, ...payload } = { ...impresoraForm, almacen_id: id };
      if (editImpresora) {
        await updateWmsImpresora(editImpresora.id, payload);
      } else {
        await createWmsImpresora(payload);
      }
      await fetchImpresoras();
      closeImpresoraModal();
    } catch (err) {
      setErrorImpresoras('Error al guardar impresora');
    } finally {
      setLoadingImpresoras(false);
    }
  };

  const handleDeleteImpresora = async (imp) => {
    if (!window.confirm('¿Eliminar impresora?')) return;
    setLoadingImpresoras(true);
    setErrorImpresoras('');
    try {
      await deleteWmsImpresora(imp.id);
      await fetchImpresoras();
    } catch {
      setErrorImpresoras('Error al eliminar impresora');
    } finally {
      setLoadingImpresoras(false);
    }
  };

  if (loading) return <div>Cargando...</div>;
  if (!almacen) return <div>No se encontró el almacén.</div>;

  const padresAgrupados = Object.values(
    ubicaciones.reduce((acc, u) => {
      if (u.nivel && u.posicion) {
        const key = `${u.pasillo_id}|${u.lado}|${u.ubicacion}`;
        if (!acc[key]) {
          acc[key] = {
            pasillo_id: u.pasillo_id,
            lado: u.lado,
            ubicacion: u.ubicacion,
            hijas: [],
            codigo: u.codigo ? u.codigo.split('-').slice(0,3).join('-') : '',
            tipo: u.tipo,
            zona: u.zona,
            capacidad: u.capacidad
          };
        }
        acc[key].hijas.push(u);
      }
      return acc;
    }, {}))
    .sort((a, b) => a.codigo.localeCompare(b.codigo));

  return (
    <div className="flex">
      {/* Sidebar drawer solo en móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ width: '256px', minHeight: '100vh' }}
      >
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      {/* Sidebar estático solo en desktop, en el flujo normal */}
      <div className="hidden md:flex">
        <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
      </div>
      <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
        <WmsTopbar rightContent={
          <button
            className="md:hidden p-2 ml-2"
            onClick={() => setSidebarOpen(true)}
            aria-label="Abrir menú"
            style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
          </button>
        } />
        <div className="flex justify-end mb-2">
          <Button 
            variant="text" 
            size="small" 
            onClick={() => navigate('/wms/almacenes')}
            style={{ color: '#2563eb', fontWeight: 500 }}
          >
            Volver a almacenes
          </Button>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8 max-w-2xl border border-blue-200">
          <div className="flex items-center gap-4 mb-4">
            <div className="bg-blue-100 rounded-full p-3 shadow">
              <WarehouseIcon style={{ fontSize: 48, color: '#2563eb' }} />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-1">{almacen.nombre}</h1>
              <div className="text-gray-500 font-mono text-sm">Código: {almacen.codigo}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="font-semibold text-gray-700">Dirección</div>
              <div className="text-gray-900">{almacen.direccion}</div>
            </div>
            <div>
              <div className="font-semibold text-gray-700">Ciudad</div>
              <div className="text-gray-900">{almacen.ciudad}</div>
            </div>
            <div>
              <div className="font-semibold text-gray-700">Estado</div>
              <div className="text-gray-900">{almacen.estado}</div>
            </div>
            <div>
              <div className="font-semibold text-gray-700">País</div>
              <div className="text-gray-900">{almacen.pais}</div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 border border-blue-100">
          <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="tabs">
            <Tab label={<span className="flex items-center gap-2"><WarehouseIcon fontSize="small" />Pasillos</span>} />
            <Tab label={<span className="flex items-center gap-2"><LocationOnIcon fontSize="small" />Ubicaciones</span>} />
            <Tab label={<span className="flex items-center gap-2"><PrintIcon fontSize="small" />Impresoras</span>} />
          </Tabs>
          <div className="mt-4">
            {tab === 0 && (
              <div>
                <h2 className="text-xl font-semibold mb-2">Pasillos</h2>
                <div className="mb-4 flex justify-end">
                  <Button variant="contained" color="primary" onClick={() => openPasilloModal()}>Crear pasillo</Button>
                </div>
                {pasillos.length === 0 ? (
                  <div className="text-gray-500">No hay pasillos registrados.</div>
                ) : (
                  <table className="w-full border rounded overflow-hidden">
                    <thead className="bg-blue-50">
                      <tr>
                        <th className="border px-2 py-1">Número</th>
                        <th className="border px-2 py-1">Ubicaciones por pasillo</th>
                        <th className="border px-2 py-1">Niveles</th>
                        <th className="border px-2 py-1">% Utilización</th>
                        <th className="border px-2 py-1">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pasillos.map((p) => (
                        <tr key={p.id} className="hover:bg-blue-50">
                          <td className="border px-2 py-1">{p.numero}</td>
                          <td className="border px-2 py-1">{p.ubicaciones_por_pasillo}</td>
                          <td className="border px-2 py-1">{p.niveles}</td>
                          <td className="border px-2 py-1 text-center">{'utilizacion' in p ? `${p.utilizacion}%` : '-'}</td>
                          <td className="border px-2 py-1 text-center">
                            <span className="inline-flex gap-2">
                              <Tooltip title="Editar">
                                <Button size="small" style={{minWidth:32}} onClick={() => openPasilloModal(p)}>
                                  <EditIcon style={{fontSize:20, color:'#2563eb'}} />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Eliminar">
                                <Button size="small" style={{minWidth:32}} onClick={() => {/* TODO: acción eliminar */}}>
                                  <DeleteIcon style={{fontSize:20, color:'#e11d48'}} />
                                </Button>
                              </Tooltip>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                <Modal open={pasilloModalOpen} onClose={closePasilloModal}>
                  <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 400, mx: 'auto', my: 8 }}>
                    <form onSubmit={handlePasilloSubmit} className="flex flex-col gap-3">
                      <TextField label="Número de pasillo" name="numero" value={pasilloForm.numero} onChange={handlePasilloFormChange} required />
                      <TextField label="Ubicaciones por pasillo" name="ubicaciones_por_pasillo" type="number" value={pasilloForm.ubicaciones_por_pasillo} onChange={handlePasilloFormChange} inputProps={{ min: 1 }} required />
                      <TextField label="Niveles" name="niveles" type="number" value={pasilloForm.niveles} onChange={handlePasilloFormChange} inputProps={{ min: 1 }} required />
                      <TextField label="Posiciones por nivel" name="posiciones_por_nivel" type="number" value={pasilloForm.posiciones_por_nivel} onChange={handlePasilloFormChange} inputProps={{ min: 1 }} required />
                      <div className="flex gap-2 justify-end mt-2">
                        <Button onClick={closePasilloModal}>Cancelar</Button>
                        <Button type="submit" variant="contained" color="primary">{editPasillo ? 'Guardar cambios' : 'Crear'}</Button>
                      </div>
                    </form>
                  </Box>
                </Modal>
              </div>
            )}
            {tab === 1 && (
              <div>
                <h2 className="text-xl font-semibold mb-2">Ubicaciones</h2>
                <div className="mb-4 flex justify-end">
                  <Button variant="contained" color="primary" onClick={() => openUbicModal()}>Crear ubicación</Button>
                </div>
                <table className="w-full border rounded overflow-hidden">
                  <thead className="bg-blue-50">
                    <tr>
                      <th className="border px-2 py-1">Código</th>
                      <th className="border px-2 py-1">Tipo</th>
                      <th className="border px-2 py-1">Zona</th>
                      <th className="border px-2 py-1">Capacidad</th>
                      <th className="border px-2 py-1">Lado</th>
                      <th className="border px-2 py-1">Ubicación</th>
                      <th className="border px-2 py-1">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {padresAgrupados.map((padre, idx) => (
                      <tr key={padre.codigo + idx} className="hover:bg-blue-50">
                        <td className="border px-2 py-1">{padre.codigo}</td>
                        <td className="border px-2 py-1">{padre.tipo}</td>
                        <td className="border px-2 py-1">{padre.zona}</td>
                        <td className="border px-2 py-1">{padre.capacidad}</td>
                        <td className="border px-2 py-1">{padre.lado}</td>
                        <td className="border px-2 py-1">{padre.ubicacion}</td>
                        <td className="border px-2 py-1 text-center">
                          <span className="inline-flex gap-2">
                            <Tooltip title="Edición masiva de posiciones hijas">
                              <Button size="small" style={{minWidth:32, background:'#f1f5f9'}} onClick={() => openEditMasiva(padre)}>
                                <span role="img" aria-label="Edición masiva" style={{fontSize:18}}>🧩</span>
                              </Button>
                            </Tooltip>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Modal open={ubicModalOpen} onClose={closeUbicModal}>
                  <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 600, mx: 'auto', my: 8 }}>
                    <form onSubmit={handleUbicSubmit} className="flex flex-col gap-3">
                      <TextField
                        select
                        label="Tipo de ubicación"
                        name="tipo"
                        value={ubicForm.tipo}
                        onChange={handleUbicFormChange}
                        required
                      >
                        <MenuItem value="Rack">Rack</MenuItem>
                        <MenuItem value="Picking">Picking</MenuItem>
                        <MenuItem value="Staging">Staging</MenuItem>
                      </TextField>
                      {ubicForm.tipo === 'Staging' ? (
                        <>
                          <TextField
                            select
                            label="Pasillo de staging"
                            name="pasillo_id"
                            value={ubicForm.pasillo_id}
                            onChange={handleUbicFormChange}
                            required
                          >
                            {pasillos.map((p) => (
                              <MenuItem key={p.id} value={p.id}>{p.numero}</MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            label="Cantidad de áreas de staging"
                            name="staging_areas"
                            type="number"
                            value={ubicForm.staging_areas || ''}
                            onChange={e => setUbicForm({ ...ubicForm, staging_areas: e.target.value })}
                            required
                          />
                          <TextField
                            label="Posiciones por área"
                            name="staging_posiciones"
                            type="number"
                            value={ubicForm.staging_posiciones || ''}
                            onChange={e => setUbicForm({ ...ubicForm, staging_posiciones: e.target.value })}
                            required
                          />
                          <div className="text-sm text-gray-600 mt-2">
                            Códigos generados:<br />
                            {(() => {
                              const areas = parseInt(ubicForm.staging_areas) || 0;
                              const posiciones = parseInt(ubicForm.staging_posiciones) || 0;
                              if (!areas || !posiciones) return <span className="text-gray-400">(Completa ambos campos para ver la previsualización)</span>;
                              let preview = [];
                              for (let a = 1; a <= areas; a++) {
                                for (let p = 1; p <= posiciones && preview.length < 10; p++) {
                                  preview.push(`STAGE-${String(a).padStart(3, '0')}-${String(p).padStart(3, '0')}`);
                                }
                                if (preview.length >= 10) break;
                              }
                              return <span>{preview.join(', ')}{(areas * posiciones > 10) ? ' ...' : ''}</span>;
                            })()}
                          </div>
                        </>
                      ) : (
                        <>
                          <TextField
                            select
                            label="Pasillo"
                            name="pasillo_id"
                            value={ubicForm.pasillo_id}
                            onChange={handleUbicFormChange}
                            required
                          >
                            {pasillos.map((p) => (
                              <MenuItem key={p.id} value={p.id}>{p.numero}</MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            label="Cantidad de ubicaciones a crear"
                            name="cantidad"
                            type="number"
                            value={ubicacionesACrear === 0 ? '' : ubicacionesACrear}
                            onChange={e => {
                              const val = e.target.value === '' ? '' : Math.max(0, Math.min(Number(e.target.value), getPasilloSeleccionado()?.ubicaciones_por_pasillo || 1));
                              setUbicacionesACrear(val);
                            }}
                            inputProps={{ min: 0, max: getPasilloSeleccionado()?.ubicaciones_por_pasillo || 1 }}
                            required
                          />
                          <TextField
                            label="Niveles por ubicación"
                            name="niveles"
                            type="number"
                            value={nivelesACrear === 0 ? '' : nivelesACrear}
                            onChange={e => {
                              const val = e.target.value === '' ? '' : Math.max(0, Math.min(Number(e.target.value), getPasilloSeleccionado()?.niveles || 1));
                              setNivelesACrear(val);
                            }}
                            inputProps={{ min: 0, max: getPasilloSeleccionado()?.niveles || 1 }}
                            required
                          />
                          <TextField
                            label="Posiciones por nivel"
                            name="posiciones"
                            type="number"
                            value={posicionesPorNivelACrear === 0 ? '' : posicionesPorNivelACrear}
                            onChange={e => {
                              const val = e.target.value === '' ? '' : Math.max(0, Math.min(Number(e.target.value), getPasilloSeleccionado()?.posiciones_por_nivel || 1));
                              setPosicionesPorNivelACrear(val);
                            }}
                            inputProps={{ min: 0, max: getPasilloSeleccionado()?.posiciones_por_nivel || 1 }}
                            required
                          />
                          <div style={{ display: 'flex', gap: 8 }}>
                            <TextField
                              label={capacidadTipo === 'm3' ? 'Capacidad' : 'Capacidad'}
                              name="capacidad"
                              value={ubicForm.capacidad}
                              onChange={handleUbicFormChange}
                              type="number"
                              required
                              style={{ flex: 2 }}
                            />
                            <TextField
                              select
                              label="Tipo"
                              name="capacidad_tipo"
                              value={capacidadTipo}
                              onChange={e => setCapacidadTipo(e.target.value)}
                              required
                              style={{ flex: 1, minWidth: 100 }}
                            >
                              <MenuItem value="m3">m³</MenuItem>
                              <MenuItem value="piezas">piezas</MenuItem>
                            </TextField>
                          </div>
                        </>
                      )}
                      {ubicForm.tipo !== 'Staging' && (
                        <>
                          <div className="text-sm text-gray-600 mb-2">Previsualización de ubicaciones a crear ({previewUbics.length}):</div>
                          <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 8 }}>
                            <table className="min-w-full text-xs border rounded bg-white">
                              <thead>
                                <tr>
                                  <th className="px-2 py-1">Código</th>
                                  <th className="px-2 py-1">Lado</th>
                                  <th className="px-2 py-1">Ubicación</th>
                                  <th className="px-2 py-1">Nivel</th>
                                  <th className="px-2 py-1">Posición</th>
                                </tr>
                              </thead>
                              <tbody>
                                {previewUbics.slice(0, 100).map((u, i) => (
                                  <tr key={i}>
                                    <td className="px-2 py-1">{u.codigo}</td>
                                    <td className="px-2 py-1">{u.lado}</td>
                                    <td className="px-2 py-1">{u.ubicacion}</td>
                                    <td className="px-2 py-1">{u.nivel}</td>
                                    <td className="px-2 py-1">{u.posicion}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {previewUbics.length > 100 && <div className="text-xs text-gray-500 mt-2">Mostrando solo los primeros 100 registros de {previewUbics.length}.</div>}
                          </div>
                        </>
                      )}
                      <div className="flex gap-2 justify-end mt-2">
                        <Button onClick={closeUbicModal}>Cancelar</Button>
                        <Button type="submit" variant="contained" color="primary">Crear</Button>
                      </div>
                    </form>
                  </Box>
                </Modal>
                <Modal open={editMasivaOpen} onClose={closeEditMasiva}>
                  <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 700, mx: 'auto', my: 8 }}>
                    <form onSubmit={handleEditMasivaSubmit} className="flex flex-col gap-3">
                      <div className="font-bold mb-2">Edición masiva de ubicaciones para {editMasivaUbic?.codigo}</div>
                      <TextField label="Niveles" type="number" value={editMasivaNiveles === 0 ? '' : editMasivaNiveles} onChange={e => {
                        const val = e.target.value === '' ? '' : Math.max(0, Number(e.target.value));
                        setEditMasivaNiveles(val);
                      }} min={1} required />
                      <TextField label="Posiciones por nivel" type="number" value={editMasivaPosiciones === 0 ? '' : editMasivaPosiciones} onChange={e => {
                        const val = e.target.value === '' ? '' : Math.max(0, Number(e.target.value));
                        setEditMasivaPosiciones(val);
                      }} min={1} required />
                      <div className="text-sm text-gray-600 mb-1 mt-2">Posiciones hijas actuales:</div>
                      <div style={{ maxHeight: 120, overflowY: 'auto', marginBottom: 8 }}>
                        <table className="min-w-full text-xs border rounded bg-white">
                          <thead>
                            <tr>
                              <th className="px-2 py-1">Código</th>
                              <th className="px-2 py-1">Nivel</th>
                              <th className="px-2 py-1">Posición</th>
                              <th className="px-2 py-1">Ocupada</th>
                            </tr>
                          </thead>
                          <tbody>
                            {editMasivaInfo?.hijas_actuales?.slice(0, 50).map((h, i) => (
                              <tr key={i}>
                                <td className="px-2 py-1">{h.codigo}</td>
                                <td className="px-2 py-1">{h.nivel}</td>
                                <td className="px-2 py-1">{h.posicion}</td>
                                <td className="px-2 py-1">{h.ocupada ? 'Sí' : 'No'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {editMasivaInfo?.hijas_actuales?.length > 50 && <div className="text-xs text-gray-500 mt-2">Mostrando solo los primeros 50 registros.</div>}
                      </div>
                      {editMasivaInfo?.no_eliminadas?.length > 0 && (
                        <div className="mb-2 p-2 rounded bg-yellow-100 text-yellow-800 text-xs font-semibold border border-yellow-300">
                          Atención: {editMasivaInfo.no_eliminadas.length} posiciones no pueden eliminarse porque están ocupadas. Estas posiciones se mantendrán.
                        </div>
                      )}
                      <div className="text-sm text-gray-600 mb-1 mt-2">Previsualización tras la edición:</div>
                      <div style={{ maxHeight: 180, overflowY: 'auto', marginBottom: 8 }}>
                        <table className="min-w-full text-xs border rounded bg-white">
                          <thead>
                            <tr>
                              <th className="px-2 py-1">Código</th>
                              <th className="px-2 py-1">Nivel</th>
                              <th className="px-2 py-1">Posición</th>
                              <th className="px-2 py-1">Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {editMasivaInfo?.previsualizacion
                              ?.slice()
                              .sort((a, b) => {
                                const [pa, la, ua, na, posa] = a.codigo.split('-');
                                const [pb, lb, ub, nb, posb] = b.codigo.split('-');
                                const npa = Number(pa), npb = Number(pb);
                                if (npa !== npb) return npa - npb;
                                if (la !== lb) return la.localeCompare(lb);
                                const nua = Number(ua), nub = Number(ub);
                                if (nua !== nub) return nua - nub;
                                const nna = Number(na), nnb = Number(nb);
                                if (nna !== nnb) return nna - nnb;
                                const nposa = Number(posa), nposb = Number(posb);
                                return nposa - nposb;
                              })
                              .slice(0, 50)
                              .map((h, i) => {
                                let bg = '';
                                let estado = 'Se mantiene';
                                if (h.nueva) {
                                  bg = 'bg-green-100 text-green-800';
                                  estado = 'Nueva';
                                } else if (h.eliminada) {
                                  bg = 'bg-red-100 text-red-800';
                                  estado = 'Se elimina';
                                } else if (h.no_eliminada) {
                                  bg = 'bg-yellow-100 text-yellow-800';
                                  estado = 'Ocupada (no se elimina)';
                                }
                                return (
                                  <tr key={i} className={bg}>
                                    <td className="px-2 py-1 font-mono">{h.codigo}</td>
                                    <td className="px-2 py-1">{h.nivel}</td>
                                    <td className="px-2 py-1">{h.posicion}</td>
                                    <td className="px-2 py-1 font-semibold">{estado}</td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                        {editMasivaInfo?.previsualizacion?.length > 50 && <div className="text-xs text-gray-500 mt-2">Mostrando solo los primeros 50 registros.</div>}
                      </div>
                      <div className="flex gap-2 justify-end mt-2">
                        <Button onClick={closeEditMasiva}>Cancelar</Button>
                        <Button type="submit" variant="contained" color="primary">Guardar cambios</Button>
                      </div>
                    </form>
                  </Box>
                </Modal>
              </div>
            )}
            {tab === 2 && (
              <div>
                <h2 className="text-xl font-semibold mb-2">Impresoras</h2>
                <div className="mb-4 flex justify-end">
                  <Button variant="contained" color="primary" onClick={() => openImpresoraModal()}>Agregar impresora</Button>
                </div>
                {loadingImpresoras && <div className="text-blue-600 mb-2">Cargando impresoras...</div>}
                {errorImpresoras && <div className="text-red-600 mb-2">{errorImpresoras}</div>}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {impresoras.length === 0 ? (
                    <div className="col-span-full text-gray-500 text-center py-2">No hay impresoras registradas.</div>
                  ) : (
                    impresoras.map((imp, idx) => (
                      <div key={imp.id || idx} className="bg-blue-50 border border-blue-200 rounded-xl shadow p-5 flex flex-col items-center relative">
                        <PrintIcon style={{ fontSize: 56, color: '#2563eb', marginBottom: 12 }} />
                        <div className="font-bold text-lg text-gray-800 mb-1">{imp.nombre}</div>
                        <div className="text-gray-600 mb-1">Tipo: <span className="font-mono">{imp.tipo_conexion}</span></div>
                        <div className="text-gray-600 mb-2">{imp.link ? `Link/IP: ${imp.link}` : 'Sin link/IP'}</div>
                        <div className="flex gap-2 absolute top-2 right-2">
                          <Tooltip title="Editar">
                            <Button size="small" style={{minWidth:32}} onClick={() => openImpresoraModal(imp)}>
                              <EditIcon style={{fontSize:20, color:'#2563eb'}} />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Eliminar">
                            <Button size="small" style={{minWidth:32}} onClick={() => handleDeleteImpresora(imp)}>
                              <DeleteIcon style={{fontSize:20, color:'#e11d48'}} />
                            </Button>
                          </Tooltip>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <Modal open={impresoraModalOpen} onClose={closeImpresoraModal}>
                  <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, maxWidth: 400, mx: 'auto', my: 8 }}>
                    <form onSubmit={handleImpresoraSubmit} className="flex flex-col gap-3">
                      <TextField label="Nombre" name="nombre" value={impresoraForm.nombre} onChange={handleImpresoraFormChange} required />
                      <TextField select label="Tipo de conexión" name="tipo_conexion" value={impresoraForm.tipo_conexion} onChange={handleImpresoraFormChange} required>
                        <MenuItem value="USB">USB</MenuItem>
                        <MenuItem value="IP">IP</MenuItem>
                        <MenuItem value="NGROK">NGROK</MenuItem>
                      </TextField>
                      <TextField label="Link/IP" name="link" value={impresoraForm.link} onChange={handleImpresoraFormChange} />
                      <div className="flex gap-2 justify-end mt-2">
                        <Button onClick={closeImpresoraModal}>Cancelar</Button>
                        <Button type="submit" variant="contained" color="primary">{editImpresora ? 'Guardar cambios' : 'Agregar'}</Button>
                      </div>
                    </form>
                  </Box>
                </Modal>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WmsAlmacenDetalle;
